import "antd/lib/list/style";
import List from "antd/lib/list";

export default List;
